// extracted by mini-css-extract-plugin
export default {"r_l":"a25eade3ca _0e4fe6340a","t":"ed8818690e"};